import React from "react";
import "../style/ModalError.css";

const ModalError = ({ show, message, onClose }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-icon">✖</div>
        <h2 className="modal-title">Error</h2>
        <p className="modal-message">{message}</p>
        <button className="modal-button" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default ModalError;
